export default {
  title: "Iniciativa"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5024: { text: "Ocurrió un error en el catálogo de Iniciativa" }
    , WS5024: { text: "Ocurrió un error en el catálogo de Iniciativa" }
    , JS5024: { text: "Ocurrió un error en el catálogo de Iniciativa" }
    , CR5024: { text: "Ocurrió un error en el catálogo de Iniciativa" }
    , UK_Iniciativa: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/iniciativa.js